import { api } from './api';

export type UploadPurpose = 'receipt' | 'pod' | 'signature' | 'vehicle_photo' | 'driver_photo' | 'document' | 'invoice_upload' | 'logo' | 'avatar';

/** presign → PUT to object storage → confirm. Resolves to the confirmed fileId. */
export async function uploadFile(file: File, purpose: UploadPurpose): Promise<string> {
  const pre = await api<{ fileId: string; uploadUrl: string; headers: Record<string, string> }>('/files/presign', { method: 'POST', json: { purpose, mime: file.type || 'application/octet-stream', sizeBytes: file.size, fileName: file.name } });
  const put = await fetch(pre.uploadUrl, { method: 'PUT', headers: pre.headers, body: file });
  if (!put.ok) throw new Error(`upload failed (${put.status})`);
  await api('/files/confirm', { method: 'POST', json: { fileId: pre.fileId } });
  return pre.fileId;
}
